// Everything related to service of intergration between TTM and Pody will be implement here
import axios from '@axios'

const baseUrl = process.env.VUE_APP_CREATIVE_SERVICE_URL

const saveCreatives = async (creatives = [], adsInfo) => {
  const payload = []
  if (creatives.length) {
    creatives.forEach(item => {
      const dataTasks = {
        taskId: item.taskId,
        videoId: item.videoId,
      }
      payload.push(dataTasks)
    })
  } else {
    const dataTasks = {
      taskId: creatives.taskId,
      videoId: creatives.videoId,
    }
    payload.push(dataTasks)
  }
  const syncPayload = {
    videoTasks: payload,
  }

  if (adsInfo) {
    syncPayload.syncToTTAM = true
    syncPayload.advertiserId = adsInfo
  }
  return axios.post(`${baseUrl}/api/creative/video`, syncPayload)
}

const deleteCreatives = async creatives => {
  const payload = []
  if (creatives.length) {
    creatives.forEach(item => {
      payload.push(item.videoId)
    })
  } else {
    payload.push(creatives.videoId)
  }

  return axios.delete(`${baseUrl}/api/creative/video?videoIds=${JSON.stringify(payload)}`)
}

const handlePodyServices = action => {
  const { type, adAccount, data } = action
  if (type && type === 'sync') {
    return saveCreatives(data, adAccount)
  }
  if (type && type === 'delete') {
    return deleteCreatives(data)
  }
  if (type && type === 'save') {
    return saveCreatives(data)
  }

  return null
}

const handlePodyConfigAction = () => {}
export {
  handlePodyServices,
  handlePodyConfigAction,
}
